import Header from "./header";
import Content from "./content";

export const FAQResource = {
	Header: Header,
	Content: Content,
}
